import ProductForm from "./product-form";
import MediaContent from "../main-product/product-media-content.jsx";
import { h, render } from "preact";

class SectionGiftCard extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.mainMedia = this.querySelector("[data-product-media]");
    this.init();

    this.productForm = new ProductForm({
      el: this,
      data: this.data,
    });
  }

  init() {
    const MainMedia = () => {
      return <MediaContent data={this.data} />;
    };

    render(<MainMedia />, this.mainMedia);
  }
}

if (!customElements.get("section-gift-card")) {
  customElements.define("section-gift-card", SectionGiftCard);
}
